(function () {
  const estimateSelector = "[data-product-shipping-estimate-output]";
  const shippingMethodsSelector = "[data-product-shipping-methods]";

  function toNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function dateKey(date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  function observedDate(year, monthIndex, day) {
    const date = new Date(year, monthIndex, day);
    const weekday = date.getDay();

    if (weekday === 6) {
      return new Date(year, monthIndex, day - 1);
    }

    if (weekday === 0) {
      return new Date(year, monthIndex, day + 1);
    }

    return date;
  }

  function nthWeekdayOfMonth(year, monthIndex, weekday, occurrence) {
    const date = new Date(year, monthIndex, 1);
    const offset = (weekday - date.getDay() + 7) % 7;
    date.setDate(1 + offset + (occurrence - 1) * 7);
    return date;
  }

  function lastWeekdayOfMonth(year, monthIndex, weekday) {
    const date = new Date(year, monthIndex + 1, 0);
    const offset = (date.getDay() - weekday + 7) % 7;
    date.setDate(date.getDate() - offset);
    return date;
  }

  function getUSHolidayKeys(year) {
    return [
      observedDate(year, 0, 1),
      nthWeekdayOfMonth(year, 0, 1, 3),
      nthWeekdayOfMonth(year, 1, 1, 3),
      lastWeekdayOfMonth(year, 4, 1),
      observedDate(year, 5, 19),
      observedDate(year, 6, 4),
      nthWeekdayOfMonth(year, 8, 1, 1),
      nthWeekdayOfMonth(year, 9, 1, 2),
      observedDate(year, 10, 11),
      nthWeekdayOfMonth(year, 10, 4, 4),
      observedDate(year, 11, 25)
    ].map(dateKey);
  }

  function isHoliday(date) {
    const year = date.getFullYear();
    const holidays = new Set([
      ...getUSHolidayKeys(year - 1),
      ...getUSHolidayKeys(year),
      ...getUSHolidayKeys(year + 1)
    ]);

    return holidays.has(dateKey(date));
  }

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let remainingDays = Math.max(0, Math.floor(days));

    while (remainingDays > 0) {
      date.setDate(date.getDate() + 1);

      if (!isWeekend(date) && !isHoliday(date)) {
        remainingDays -= 1;
      }
    }

    return date;
  }

  function addCalendarDays(startDate, days) {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    date.setDate(date.getDate() + Math.max(0, Math.floor(days)));
    return date;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric"
    }).format(date);
  }

  function formatRange(startDate, endDate) {
    return `${formatDate(startDate)} \u2013 ${formatDate(endDate)}`;
  }

  function getConfig() {
    const config = window.productShippingEstimate || {};
    const shippingProfiles = Array.isArray(config.shippingProfiles) ? config.shippingProfiles : [];
    const normalizedProfiles = shippingProfiles
      .map((profile) => ({
        label: String(profile.label || "Standard Shipping (12-15 calendar days)"),
        minDays: toNumber(profile.minDays, 12),
        maxDays: toNumber(profile.maxDays, 15)
      }))
      .filter((profile) => profile.minDays >= 0 && profile.maxDays >= profile.minDays);

    return {
      processingDays: toNumber(config.processingDays, 3),
      shippingProfiles: normalizedProfiles.length
        ? normalizedProfiles
        : [{ label: "Standard Shipping (12-15 calendar days)", minDays: 12, maxDays: 15 }]
    };
  }

  function getShortShippingLabel(label) {
    return String(label || "").replace(/\s*\([^)]*\)\s*$/, "");
  }

  function renderLines(element, lines, singleLineValue) {
    element.textContent = "";

    if (lines.length === 1 && singleLineValue) {
      element.textContent = singleLineValue;
      return;
    }

    lines.forEach((line) => {
      const item = document.createElement("span");
      item.style.display = "block";
      item.textContent = line;
      element.appendChild(item);
    });
  }

  function updateShippingEstimate() {
    const outputs = document.querySelectorAll(estimateSelector);
    const shippingMethodOutputs = document.querySelectorAll(shippingMethodsSelector);

    if (!outputs.length && !shippingMethodOutputs.length) {
      return;
    }

    const config = getConfig();
    const today = new Date();
    const processingCompleteDate = addBusinessDays(today, config.processingDays);
    const estimateLines = config.shippingProfiles.map((profile) => {
      const earliestDate = addCalendarDays(processingCompleteDate, profile.minDays);
      const latestDate = addCalendarDays(processingCompleteDate, profile.maxDays);
      return `${getShortShippingLabel(profile.label)}: ${formatRange(earliestDate, latestDate)}`;
    });
    const shippingLines = config.shippingProfiles.map((profile) => {
      return `${getShortShippingLabel(profile.label)}: ${profile.minDays}\u2013${profile.maxDays} calendar days`;
    });

    outputs.forEach((output) => {
      renderLines(output, estimateLines, estimateLines[0].replace(/^.*?:\s*/, ""));
    });

    shippingMethodOutputs.forEach((output) => {
      renderLines(output, shippingLines, shippingLines[0].replace(/^.*?:\s*/, ""));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateShippingEstimate);
  } else {
    updateShippingEstimate();
  }

  document.addEventListener("shopify:section:load", updateShippingEstimate);
})();
